import styled from "styled-components"

import ButtonBase from "~/themes/school/components/Button"

import background from "./background.svg"

export const PageContent = styled.div`
	background-color: white;
	background-image: url(${background});
	background-size: cover;
	background-position: center center;
	padding: 24px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	margin-bottom: 24px;

	@media (min-width: 1000px) {
		min-height: calc(100vh - ${42 + 28 + 32 + 42}px);
		padding: 42px;
		margin-bottom: 42px;
	}
`

export const Buttons = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;

	@media (min-width: 1000px) {
		display: grid;
		grid-template-areas: "previous next skipChapter";
		gap: 16px;
	}
`

export const Button = styled(ButtonBase)`
	min-width: 150px;

	@media (max-width: 999px) {
		min-width: 0;
		flex: 1;
	}
`
